
export const EVENT_ICONS = {
  show: 'fa-ticket',
  stay: 'fa-bed',
  nost: 'fa-bus',
  prep: 'fa-microphone',
  trav: 'fa-plane',
  off: 'fa-glass',
  default: 'fa-question',
};
export const EVENT_NAMES = {
  show: 'Show',
  stay: 'Stay',
  nost: 'No Hotel Stay',
  prep: 'Prep Work',
  trav: 'Travel Day',
  off: 'Off Day',
  default: 'Not sure..',
};

export const EVENT_COLORS = {
  show: '#FF9800',
  stay: '#7986CB',
  nost: '#BA68C8',
  prep: '#EC407A',
  trav: '#4CAF50',
  off: '#29B6F6',
  default: '#FFEE58',
};

export const GROUP_COLORS = {
  0: '#283593',
  1: '#0D47A1',
  2: '#01579B',
  3: '#006064',
};



// WEBPACK FOOTER //
// src/routes/tours/components/EventStyles.js